import { LatitudeLongitude } from '@aloft/toolkit-shared';
import { bbox, featureCollection, point } from '@turf/turf';

import { LngLatBoundsLike, Map } from 'mapbox-gl';

export const fitBounds = (map: Map, comps: Partial<LatitudeLongitude>[]) => {
  const bounds = bbox(
    featureCollection(
      comps.reduce((acc: ReturnType<typeof point>[], comp) => {
        if (!comp.latitude || !comp.longitude) return acc;

        return [...acc, point([comp.longitude, comp.latitude])];
      }, []),
    ),
  ) as LngLatBoundsLike;

  if (bounds) map.fitBounds(bounds, { padding: 80 });
};
